import request from '../../../api/request';
import { StudentDocumentsResponse } from '../parts/StudentDocuments/types';

const STUDENT_DOCUMENTS = {
  GET_STUDENT_DOCUMENTS: (studentId: string | number) =>
    `maintainers-portal/student-management/student-documents/${studentId}`,
  POST_STUDENT_DOCUMENTS: (studentId: string | number) =>
    `maintainers-portal/student-management/student-documents/${studentId}/student-document`,
  DELETE_STUDENT_DOCUMENTS: (
    studentId: string | number,
    studentDocumentId: number,
  ) =>
    `maintainers-portal/student-management/student-documents/${studentId}/student-document/${studentDocumentId}`,
  GET_STUDENT_DOCUMENTS_DOWNLOAD: (
    studentId: string | number,
    studentDocumentId: number,
  ) =>
    `maintainers-portal/student-management/student-documents/${studentId}/student-document/${studentDocumentId}/download`,
  GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD: (
    studentId: string | number,
  ) =>
    `maintainers-portal/student-management/student-documents/${studentId}/tuition-documents/download`,
};

export function getStudentDocuments(studentId: number) {
  return request<StudentDocumentsResponse>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS(studentId),
  );
}

export function getStudentDocumentsTuitionDocumentDownload(
  studentId: number,
  params: { type: string; documentId: number | string },
) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD(
      studentId,
    ),
    {
      params,
    },
  );
}

export function getStudentDocumentsTuitionDocumentView(
  studentId: number,
  params: { type: string; documentId: number | string },
) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD(
      studentId,
    ),
    {
      params: { ...params, inline: true },
    },
  );
}

export function createStudentDocument(
  studentId: number,
  data: { name: string; description: string | null; fileId: string },
) {
  return request<unknown>(STUDENT_DOCUMENTS.POST_STUDENT_DOCUMENTS(studentId), {
    method: 'POST',
    data,
  });
}

export function getStudentDocumentDownload({
  studentId,
  studentDocumentId,
}: {
  studentId: number;
  studentDocumentId: number;
}) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_DOWNLOAD(
      studentId,
      studentDocumentId,
    ),
  );
}

export function deleteStudentDocument({
  studentId,
  studentDocumentId,
}: {
  studentId: number;
  studentDocumentId: number;
}) {
  return request<unknown>(
    STUDENT_DOCUMENTS.DELETE_STUDENT_DOCUMENTS(studentId, studentDocumentId),
    {
      method: 'DELETE',
    },
  );
}
